import React, {
    useState,
    useEffect,
    useCallback
} from 'react';
import {
    Switch, Route, Redirect, BrowserRouter as Router
} from 'react-router-dom';
import _ from 'lodash';
// Imported First to allow Jutro styles to be overridden
import './App.scss';
import { setComponentMapOverrides } from '@jutro/uiconfig';
import {
    Main,
    useModal,
    ModalNextEmitter
} from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { NavRoutes, routeConfirmationModal } from '@jutro/router';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import {
    DynamicRoute, GrantedAuthorities, withAuthContextProvider, useAuthentication
} from 'gw-digital-auth-react';
import vmTranslator, { messages as commonMessages } from 'gw-platform-translations';
import { AccurateBreakpointPropagation } from 'gw-jutro-adapters-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import { ViewModelServiceFactory } from 'gw-portals-viewmodel-js';
import { PolicyDetails } from 'gw-capability-policy-react';
import { AvailabilityService } from 'gw-capability-policycommon';
import { EndorsementService } from 'gw-capability-policychange';
import { PAPolicyChangeWizard } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeWizard } from 'gw-capability-policychange-ho-react';
import { LoginCapabilityComponentMap, LoginCapabilityComponents } from 'gw-portals-login-react';
import { personalizedOfferComponentMap, personalizedOfferComponents } from 'gw-capability-personalizedoffers-react';
import { VehicleInfoLookupComponentMap, VehicleInfoLookupComponents } from 'gw-capability-vehicleinfo-react';
import { policyJobComponentMap, policyJobComponents } from 'gw-capability-policyjob-react';
import {
    BillingSummaryPage,
    MakePaymentPage,
    billingComponentMap,
    billingAdditionalComponents
} from 'gw-capability-billing-react';
import { AdditionalEnrollment, SignUpEnrollment } from 'gw-capability-enrollment-react';
import {
    UsersProfile, EditProfile, ChangePassword, RIFormsOrderingPage
} from 'gw-capability-profileinfo-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import { ProducerInfoService } from 'gw-capability-profileinfo';

import { DependencyProvider } from 'gw-portals-dependency-react';
import { AccountBillingDetailsService, BillingService } from 'gw-capability-billing';
import { PolicyService } from 'gw-capability-policy';
import { ClaimDocumentService } from 'gw-capability-claimdocument';

import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {
    platformComponentMap,
    platformComponents,
    ImageComponent,
} from 'gw-components-platform-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import BaseFNOLWizard, { ClaimsConfirmationPage } from 'gw-capability-fnol-common-react';
import { ContactAgentPage } from 'gw-pages-platform-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import FNOLHOWizard from 'gw-capability-fnol-ho-react';
import FNOLCPWizard from 'gw-capability-fnol-cp-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';

import {
    ClaimList, ClaimDetails, PolicyLevelCoverages, CreateNote
} from 'gw-capability-claim-react';
import { ClaimService } from 'gw-capability-claim';
import FNOLService from 'gw-capability-fnol'; 
import FaqPage from 'gw-capability-faq-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import { filterCapabilityRoutes, filterPermissionRoutes_RI} from 'gw-portals-config-js';
import { PaymentFrame, PaymentDetails } from 'gw-capability-ri-policy-payment-react';
import { PayrollFrame } from 'gw-capability-ri-policy-epay-react';
import { RIPolicyDetails } from 'gw-capability-ri-policy-react';
import { AdminLanding, ManageRIUsers, MyNotifications } from 'gw-capability-ri-policy-admin-react';
import { BillingLanding } from 'gw-capability-ri-billing-react';
import { ClaimsLanding, ClaimInfos, ClaimsFrame, ClaimFileUpload } from 'gw-capability-ri-claim-react';
import PageHeaderComponent from '../components/PageHeaderComponent/PageHeaderComponent';
import { routes } from './App.routes.metadata.json5';
import ResetPasswordPage from '../pages/ResetPasswordPage/ResetPasswordPage';
import EntryPage from '../pages/EntryPage/EntryPage';
import LandingPage from '../pages/LandingPage/LandingPage';
import messages from './App.messages';

const { capabilitiesConfig } = appConfig;

const componentMap = {
    landingpage: LandingPage,
    policydocumenterror: PolicyDocumentError,
    fnolwcwizard: FNOLWCWizard,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagent: ContactAgentPage,
    fnolpawizard: FNOLPAWizard,
    fnolhowizard: FNOLHOWizard,
    additionalenrollmentpage: AdditionalEnrollment,
    claimlist: ClaimList,
    claimdetails: ClaimDetails,
    policydetailspage: PolicyDetails,
    papolicychangewizard: PAPolicyChangeWizard,
    hopolicychangewizard: HOPolicyChangeWizard,
    createnote: CreateNote,
    billingsummarypage: BillingSummaryPage,
    makepaymentpage: MakePaymentPage,
    usersprofile: UsersProfile,
    policylevelcoverages: PolicyLevelCoverages,
    faqpage: FaqPage,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    paymentframepage: PaymentFrame,
    payrollframepage: PayrollFrame,
    eclaimsframepage: ClaimsFrame,
    billinglanding: BillingLanding,
    adminlanding: AdminLanding,
    ripolicydetails: RIPolicyDetails,
    claimslanding: ClaimsLanding,
    claiminfos: ClaimInfos,
    richangepassword: ChangePassword,
    rieditprofile: EditProfile,
    riFormsOrderingPage: RIFormsOrderingPage,
    riManageRIUsers: ManageRIUsers,
    mynotifications: MyNotifications,
    riClaimFileUpload: ClaimFileUpload
};

const shouldRouteToSignUp = (authorities) => {
    const accountAuthorities = authorities.filter((authority) => authority.authorityType === 'ACCOUNT');
    // if user doesn't have ACCOUNT authorities it is supposed to be enrolled
    // vp::: Temp commented out as this is not developed in RI PC
    // if (accountAuthorities.length === 0) {
    //     return <Redirect to="/signup-enrollment" />;
    // }
    return null;
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...personalizedOfferComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...LoginCapabilityComponentMap,
        ...policyJobComponentMap,
        ...billingComponentMap,
        WizardPageTemplateWithTitle: { component: 'WizardPageTemplateWithTitle' },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
    },
    {
        ...platformComponents,
        ...personalizedOfferComponents,
        ...VehicleInfoLookupComponents,
        ...LoginCapabilityComponents,
        ...policyJobComponents,
        ...billingAdditionalComponents,
        WizardPageTemplateWithTitle,
        img: ImageComponent,
    }
);

// (Router) Title is required and used for (Browser) title
// in a format of "${title} - ${appName}". In order to show
// the application name only, it needs to be an empty value.
const routesWithTitle = filterCapabilityRoutes(capabilitiesConfig, routes);
const routesWithoutTitle = routesWithTitle.map((route) => {
    return {
        ...route,
        title: ''
    };
});

const riRoutesWithTitle = (auth) => {
    return filterPermissionRoutes_RI(auth.authUserData, routesWithTitle);
};

const modalEmitter = new ModalNextEmitter();
// FB 23003 -----
const isCheckIfLoggedInError = (error) => {
    return _.get(error, 'error') === 'checkIfLoggedInError';
};
// ----- FB 23003

function App() {
    const {
        showAlert
    } = useModal();

    const translator = useTranslator();
    const [viewModelService, setViewModelService] = useState(undefined);
    const auth = useAuthentication();
    useEffect(() => {
        const translatorFn = vmTranslator(translator);
        import(
            /* webpackChunkName: "product-metadata" */
            // eslint-disable-next-line import/no-unresolved
            'product-metadata'
        ).then((productMetadata) => {
            const { default: result } = productMetadata;
            setViewModelService(
                ViewModelServiceFactory.getViewModelService(result, translatorFn)
            );
        });
    }, [translator]);

    const handleError = useCallback((error) => {        
        // FB 23003 -------------------------
        if (isCheckIfLoggedInError(error)) {
            return showAlert({
                title: 'Access Restricted',
                message: (
                    <>
                        <p>The account associated with this policy is not accessible.</p>
                        <p>Please contact <strong>Customer Care</strong> at{' '}
                        <a href="mailto:RICACustomerCare@ri-net.com">RICACustomerCare@ri-net.com</a></p>
                    </>
                ),
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            })
                .then(() => {
                    if (auth && auth.logout) {
                        return auth.logout();
                    }
                    return Promise.resolve();
                })
                .catch(_.noop);
        }
        // ------------------------ FB 23003

        return showAlert({
            title: messages.error,
            message: messages.errorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, [auth, showAlert]);

    // FB 23003 -------------------------
    useEffect(() => {
        const handleGlobalError = (event) => {
            const caughtError = _.get(event, 'error') || _.get(event, 'reason') || event;            
            handleError(caughtError);
        };

        window.addEventListener('error', handleGlobalError);
        window.addEventListener('unhandledrejection', handleGlobalError);

        return () => {
            window.removeEventListener('error', handleGlobalError);
            window.removeEventListener('unhandledrejection', handleGlobalError);
        };
    }, [handleError]);
    // ------------------------ FB 23003
    
    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    AccountBillingDetailsService: AccountBillingDetailsService,
                    PolicyService: PolicyService,
                    EndorsementService: EndorsementService,
                    AvailabilityService: AvailabilityService,
                    FNOLService: FNOLService,
                    ClaimService: ClaimService,
                    ClaimDownloadService: ClaimDocumentService,
                    BillingService: BillingService,
                    EnrollmentService: EnrollmentService,
                    ContactService: ProducerInfoService,
                }}
            >
                <ErrorBoundary onError={handleError}>
                    <ViewModelServiceContext.Provider value={viewModelService}>
                        <Router
                            basename="/account-management"
                            getUserConfirmation={
                                (message, callback) => {
                                    return routeConfirmationModal(message, callback, modalEmitter);
                                }
                            }
                        >
                            <Switch>
                                <Route exact path="/login-page" component={EntryPage} />
                                <Route exact path="/auth/resetpassword" component={ResetPasswordPage} />
                                <Route exact path="/signup-enrollment" component={SignUpEnrollment} />
                                <Route exact path="/account-management/ri-payroll/:id" component={PayrollFrame} />
                                <DynamicRoute path="/">
                                    <GrantedAuthorities
                                        checkRenderBasedOnAuthorities={shouldRouteToSignUp}
                                    >
                                        <PageHeaderComponent routes={riRoutesWithTitle(auth)} />
                                        <Main>
                                            <NavRoutes
                                                resolveComponentMap={componentMap}
                                                routes={routesWithoutTitle}
                                            />
                                        </Main>
                                    </GrantedAuthorities>
                                </DynamicRoute>
                            </Switch>
                        </Router>
                    </ViewModelServiceContext.Provider>
                </ErrorBoundary>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}

export default withAuthContextProvider()(App);
